import { render } from "./DetailsStockReport.vue?vue&type=template&id=32f26c54&scoped=true"
import script from "./DetailsStockReport.vue?vue&type=script&lang=js"
export * from "./DetailsStockReport.vue?vue&type=script&lang=js"

import "./DetailsStockReport.vue?vue&type=style&index=0&id=32f26c54&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f26c54"]])

export default __exports__